export const TERMS_OF_SERVICE = 'https://soona.co/terms';

export const PRIVACY_POLICY = 'https://www.trend.io/privacy-policy';
